import { ReactNode, createContext, useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { WithdrawResponse } from '../services/WithdrawService/withdraw'
import { useWithdraws } from '../hooks/useWithdraws'

interface FiltersType {
  startDate?: string
  endDate?: string
  status?: string
}

interface WithdrawContextValue {
  setSkip: (value: number) => void
  debouncedSearchValue?: string
  withdraw: {
    isLoading: boolean
    isFetching: boolean
    data: WithdrawResponse | undefined
  }
  setFilterParams: (value: FiltersType) => void
  sellerId: string | undefined
}

export const WithdrawContext = createContext({} as WithdrawContextValue)

export const WithdrawProvider = ({ children }: { children: ReactNode }) => {
  const { id } = useParams()

  const setSkip = (value: number) => {
    setParams((state) => ({ ...state, skip: value }))
  }
  const setFilterParams = (value: FiltersType) => {
    setParams(value)
  }

  const { setParams, ...withdraw } = useWithdraws()

  const setSellerId = useCallback(() => {
    setParams((state) => ({ ...state, sellerId: id, sort: '-createdAt' }))
  }, [id, setParams])

  useEffect(() => {
    setSellerId()
  }, [setSellerId])

  return (
    <WithdrawContext.Provider
      value={{
        setSkip,
        withdraw,
        setFilterParams,
        sellerId: id,
      }}
    >
      {children}
    </WithdrawContext.Provider>
  )
}
